import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const Customers = () => {
  const server_url = localStorage.getItem("server_url");
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const navigate = useNavigate();

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(null);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    customer: null,
  });
  const [vehiclesModal, setVehiclesModal] = useState({
    isOpen: false,
    customerId: null,
    vehicles: [],
    loading: false,
  });

  useEffect(() => {
    fetchCustomers();
  }, []);

  useEffect(() => {
    if (searchText.trim() == "") {
      setFilteredCustomers(customers);
    } else {
      const filtered = customers.filter(
        (customer) =>
          customer.customer_name
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          customer.customer_mobile.includes(searchText) ||
          customer.customer_area
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          customer.customer_address
            .toLowerCase()
            .includes(searchText.toLowerCase())
      );
      setFilteredCustomers(filtered);
    }
  }, [searchText, customers]);

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("customer_grage_id", userData.grage_id || "1");
      formData.append("searh_text", "");

      const response = await axios.post(`${server_url}customer.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status == "1") {
        setCustomers(response.data.result || []);
        setFilteredCustomers(response.data.result || []);
      } else {
        toast.error(response.data.error || "Failed to fetch customers");
        setCustomers([]);
        setFilteredCustomers([]);
      }
    } catch (error) {
      console.error("Fetch customers error:", error);
      toast.error("Unable to fetch customers. Please try again.");
      setCustomers([]);
      setFilteredCustomers([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomerVehicles = async (customerId) => {
    setVehiclesModal((prev) => ({ ...prev, loading: true }));
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("customer_id", customerId);
      formData.append("vehicle_grage_id", userData.grage_id || "1");
      formData.append("vehicle_reg_no", "");

      const response = await axios.post(`${server_url}vehicle.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status == "1") {
        setVehiclesModal({
          isOpen: true,
          customerId,
          vehicles: response.data.result || [],
          loading: false,
        });
      } else {
        toast.error(response.data.error || "Failed to fetch vehicles");
        setVehiclesModal((prev) => ({ ...prev, loading: false }));
      }
    } catch (error) {
      console.error("Fetch customer vehicles error:", error);
      toast.error("Unable to fetch vehicles. Please try again.");
      setVehiclesModal((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleSearch = (e) => {
    if (e) e.preventDefault();
    fetchCustomers();
  };

  const handleCall = (mobile) => {
    window.open(`tel:${mobile}`);
  };

  const handleEditCustomer = (customer) => {
    navigate("/edit-customer", { state: { customer } });
  };

  const handleViewVehicles = (customer) => {
    fetchCustomerVehicles(customer.customer_id);
  };

  const handleEditVehicle = (vehicle) => {
    setVehiclesModal((prev) => ({ ...prev, isOpen: false }));
    navigate("/edit-vehicle", { state: { vehicle } });
  };

  const handleAddCustomer = () => {
    navigate("/add-customer-vehicle");
  };

  const openDeleteModal = (customer) => {
    setDeleteModal({ isOpen: true, customer });
  };

  const closeDeleteModal = () => {
    setDeleteModal({ isOpen: false, customer: null });
  };

  const confirmDeleteCustomer = async () => {
    const customer = deleteModal.customer;
    if (!customer) return;

    setDeleteLoading(customer.customer_id);
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("customer_id", customer.customer_id);

      const response = await axios.post(
        `${server_url}delete_customer.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.status == "1") {
        toast.success("Customer deleted successfully!");
        setCustomers((prev) =>
          prev.filter((c) => c.customer_id !== customer.customer_id)
        );
        setFilteredCustomers((prev) =>
          prev.filter((c) => c.customer_id !== customer.customer_id)
        );
        closeDeleteModal();
      } else {
        toast.error(response.data.error || "Failed to delete customer");
      }
    } catch (error) {
      console.error("Delete customer error:", error);
      toast.error("Unable to delete customer. Please try again.");
    } finally {
      setDeleteLoading(null);
    }
  };

  const closeVehiclesModal = () => {
    setVehiclesModal({
      isOpen: false,
      customerId: null,
      vehicles: [],
      loading: false,
    });
  };

  return (
    <div className="history-container">
      {/* Sticky Header Section */}
      <div
        className="sticky-filter"
        style={{ position: "fixed", top: "56px", width: "100%" }}
      >
        <div className="home-icon">
          <div className="section-home">
            <form onSubmit={handleSearch} className="search-form">
              <div className="input-group same-line">
                <input
                  type="text"
                  placeholder="Search customers..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyPress={(e) => e.key == "Enter" && handleSearch()}
                  className="search-input"
                />
                <button type="submit" className="search-btn">
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="content-area">
        {/* Customers List */}
        <div className="home-vehicles">
          {loading ? (
            <div className="loading-vehicles">
              <div className="loading-spinner"></div>
              <div>Loading customers...</div>
            </div>
          ) : filteredCustomers.length > 0 ? (
            <div className="vehicles-list home-icon">
              {filteredCustomers.map((customer) => (
                <div
                  key={customer.customer_id}
                  className="vehicle-card section-home"
                >
                  <div className="vehicle-header">
                    <table style={{ width: "100%", textAlign: "left" }}>
                      <tbody>
                        {/* Customer Name */}
                        <tr>
                          <td
                            style={{
                              width: "70%",
                              fontWeight: "bold",
                              fontSize: "16px",
                            }}
                            onClick={() => handleEditCustomer(customer)}
                          >
                            {customer.customer_name || ""}
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              width: "30%",
                              fontWeight: "bold",
                              color: "#0352a1",
                            }}
                          >
                            <button
                              onClick={() => openDeleteModal(customer)}
                              disabled={deleteLoading == customer.customer_id}
                              style={{
                                flex: 1,
                                border: "none",
                                cursor: "pointer",
                                fontSize: "19px",
                                fontWeight: "500",
                                backgroundColor: "transparent",
                              }}
                            >
                              {deleteLoading == customer.customer_id ? (
                                <i className="fas fa-spinner fa-spin"></i>
                              ) : (
                                <>
                                  <i
                                    className="fas fa-trash"
                                    style={{
                                      marginRight: "5px",
                                      color: "#DB4437",
                                    }}
                                  ></i>
                                </>
                              )}
                            </button>
                          </td>
                        </tr>

                        <tr>
                          <td
                            colSpan="2"
                            style={{
                              fontSize: "14px",
                              color: "#2c3e50",
                              padding: "4px 0",
                            }}
                            onClick={() => handleEditCustomer(customer)}
                          >
                            {customer.customer_mobile || ""}
                          </td>
                        </tr>

                        {/* Area */}
                        {customer.customer_area && (
                          <tr>
                            <td
                              colSpan="2"
                              style={{
                                fontSize: "13px",
                                color: "#666",
                                padding: "2px 0",
                              }}
                              onClick={() => handleEditCustomer(customer)}
                            >
                              <i
                                className="fas fa-map-marker-alt"
                                style={{ marginRight: "8px" }}
                              ></i>
                              {customer.customer_area}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-vehicles section-home">
              <div className="no-vehicles-icon">👥</div>
              <div className="no-vehicles-title">No Customers Found</div>
              <div className="no-vehicles-text">
                {searchText
                  ? "Try adjusting your search terms"
                  : "No customers available"}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Floating Add Button */}
      <button
        className="floating-add-btn"
        onClick={handleAddCustomer}
        title="Add New Customer"
      >
        <i className="fas fa-plus"></i>
      </button>

      {/* Delete Confirmation Modal */}
      {deleteModal.isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              width: "100%",
              maxWidth: "350px",
              padding: "24px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                margin: "0 auto 20px",
                backgroundColor: "#fee2e2",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i
                className="fas fa-exclamation-triangle"
                style={{ fontSize: "24px", color: "#dc2626" }}
              ></i>
            </div>

            <h3
              style={{
                margin: "0 0 12px 0",
                fontSize: "18px",
                fontWeight: "600",
                color: "#1f2937",
              }}
            >
              Delete Customer
            </h3>
            <p
              style={{
                margin: "0 0 24px 0",
                color: "#6b7280",
                fontSize: "14px",
              }}
            >
              Are you sure you want to delete{" "}
              <strong>{deleteModal.customer?.customer_name}</strong>? This
              action cannot be undone.
            </p>

            <div style={{ display: "flex", gap: "12px" }}>
              <button
                onClick={closeDeleteModal}
                disabled={deleteLoading !== null}
                style={{
                  flex: 1,
                  padding: "12px",
                  border: "2px solid #e2e8f0",
                  background: "white",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmDeleteCustomer}
                disabled={deleteLoading !== null}
                style={{
                  flex: 1,
                  padding: "12px",
                  background: "#dc2626",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {deleteLoading == deleteModal.customer?.customer_id ? (
                  <>
                    <i
                      className="fas fa-spinner fa-spin"
                      style={{ marginRight: "5px" }}
                    ></i>
                    Deleting...
                  </>
                ) : (
                  "Delete"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Vehicles Modal */}
      {vehiclesModal.isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              width: "100%",
              maxWidth: "500px",
              maxHeight: "70vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px",
                borderBottom: "1px solid #e2e8f0",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#2d3748",
                }}
              >
                Customer Vehicles
              </h3>
              <button
                onClick={closeVehiclesModal}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#718096",
                }}
              >
                ×
              </button>
            </div>

            <div style={{ flex: 1, overflowY: "auto", padding: "20px" }}>
              {vehiclesModal.loading ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    color: "#666",
                  }}
                >
                  <div
                    className="loading-spinner"
                    style={{ margin: "0 auto 15px" }}
                  ></div>
                  Loading vehicles...
                </div>
              ) : vehiclesModal.vehicles.length > 0 ? (
                vehiclesModal.vehicles.map((vehicle) => (
                  <div
                    key={vehicle.vehicle_id}
                    style={{
                      background: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "16px",
                      marginBottom: "12px",
                      borderLeft: "4px solid #0352a1",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <strong style={{ fontSize: "16px", color: "#2d3748" }}>
                          {vehicle.vehicle_reg_no}
                        </strong>
                        {vehicle.vehicle_reg_name && (
                          <div
                            style={{
                              fontSize: "14px",
                              color: "#4a5568",
                              marginTop: "4px",
                            }}
                          >
                            {vehicle.vehicle_reg_name}
                          </div>
                        )}
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#666",
                            marginTop: "4px",
                          }}
                        >
                          {vehicle.brand_name} {vehicle.model_name}
                        </div>
                      </div>
                      <button
                        onClick={() => handleEditVehicle(vehicle)}
                        style={{
                          background: "#ed8936",
                          color: "white",
                          border: "none",
                          padding: "6px 12px",
                          borderRadius: "6px",
                          cursor: "pointer",
                          fontSize: "13px",
                        }}
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    color: "#666",
                  }}
                >
                  <div style={{ fontSize: "48px", marginBottom: "15px" }}>
                    🚗
                  </div>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      marginBottom: "8px",
                    }}
                  >
                    No Vehicles Found
                  </div>
                  <div>This customer has no vehicles registered.</div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .history-container {
          min-height: 100vh;
          background: white;
          padding: 0;
          position: relative;
        }

        /* Sticky Filter Styles */
        .sticky-filter {
          position: sticky;
          top: 0;
          z-index: 100;
          background: white;
          padding: 8px 0;
          border-bottom: 1px solid #e2e8f0;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .content-area {
          padding-top: 8px;
          padding-bottom: 80px;
        }

        /* Search/Filters Section */
        .home-icon .section-home {
          padding: 8px 12px 12px 12px;
        }
        .home-icon {
          padding-left: 0px;
          padding-right: 0px;
        }

        .input-group.same-line {
          display: flex;
          gap: 12px;
          align-items: center;
        }

        .input-group.same-line .search-input {
          flex: 1;
        }

        .search-input {
          padding: 12px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 14px;
          background: #f8f9fa;
          width: 100%;
        }

        .search-btn {
          background: #0352a1;
          color: white;
          border: none;
          border-radius: 12px;
          padding: 13px 15px;
          min-width: 40px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* Heading Section */
        .heading-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }

        .sa-title {
          font-size: 18px;
          font-weight: 600;
          color: #2d3748;
        }

        /* Vehicles List */
        .home-vehicles {
          padding: 30px 10px;
        }

        .loading-vehicles {
          text-align: center;
          padding: 40px 20px;
          color: #666;
        }

        .loading-spinner {
          width: 30px;
          height: 30px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #0352a1;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 15px;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .vehicles-list {
          display: grid;
          gap: 15px;
        }

        .vehicle-card {
          background: #f8f9fa;
          border-radius: 12px;
          padding: 16px;
          border-left: 4px solid #0352a1;
          transition: all 0.3s ease;
        }

        .vehicle-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .vehicle-header {
          width: 100%;
        }

        .vehicle-header table {
          width: 100%;
          border-collapse: collapse;
        }

        .vehicle-header td {
          padding: 4px 0;
          vertical-align: top;
        }

        /* No Vehicles State */
        .no-vehicles {
          text-align: center;
          padding: 40px 20px;
          background: #f8f9fa;
          border-radius: 12px;
          margin: 20px 0;
        }

        .no-vehicles-icon {
          font-size: 48px;
          margin-bottom: 15px;
        }

        .no-vehicles-title {
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 8px;
        }

        .no-vehicles-text {
          color: #666;
          margin-bottom: 20px;
        }

        /* Floating Add Button */
        .floating-add-btn {
          position: fixed;
          bottom: 80px;
          right: 20px;
          width: 60px;
          height: 60px;
          background: #0352a1;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(3, 82, 161, 0.3);
          z-index: 99;
          transition: all 0.3s ease;
          border: none;
        }

        .floating-add-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 16px rgba(3, 82, 161, 0.4);
        }

        .floating-add-btn:active {
          transform: scale(0.95);
        }

        @media (max-width: 768px) {
          .content-area {
            padding-top: 60px;
          }

          .home-vehicles {
            padding: 25px 10px;
          }

          .vehicle-card {
            padding: 12px;
          }

          .vehicle-header td {
            font-size: 14px;
          }

          .sticky-filter {
            padding: 6px 0;
          }

          .floating-add-btn {
            bottom: 70px;
            right: 15px;
            width: 56px;
            height: 56px;
            font-size: 22px;
          }
        }

        @media (max-width: 480px) {
          .sticky-filter {
            padding: 4px 0;
          }

          .floating-add-btn {
            bottom: 60px;
            right: 12px;
            width: 52px;
            height: 52px;
            font-size: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default Customers;
